import { OpenBetColorTheme } from "./ob-color-scheme.interface";

export const COLORS_LIGHT: OpenBetColorTheme = {
    l: {
        primary: {
            main: "#1E5BCE",
            light1: "#4281F5",
            light2: "#4281F5" /* not used */,
            light3: "#4281F5" /* not used */,
            deep: "#164398",
            contrast: "#FFFFFF",
            hover: "#1E5BCE0A", // 4%
            selected: "#1E5BCE14", //8 %
            focus: "#1E5BCE1F", // 30%
            outlined_border: "#1E5BCE80", // 50%
        },
        secondary: {
            main: "#D2DEF5",
            deep: "#BBCEF0",
            contrast: "#133B86",
        },
        neutral: {
            0: "#FFFFFF",
            50: "#FAFAFA",
            100: "#F5F5F5",
            200: "#EEEEEE",
            300: "#00000029",
            400: "#BDBDBD",
            500: "#9E9E9E",
            600: "#757575",
            700: "#616161",
            800: "#424242",
            900: "#212121",
            1000: "#000000",
        },
        text: {
            primary: "#000000",
            secondary: "#00000099", // 60%
            disabled: "#00000061", // 38%
            contrast: "#FFFFFF", //
        },
        background: {
            main: "#F5F5F5",
            components: "#FFFFFF",
            fill: "#F5F5F5",
            menu: "#FFFFFF",
            // header: '#FFFFFF', /* new */
            // menu_header: '#FFFFFF', /* new */
            // menu_scroll: '#FAFAFA', /* new */
            // menu_hover: '#F5F5F5', /* new */
            filter_header: "#E0E0E0" /* new */,
            // paper_elevation4: '#F5F5F5' /* new */
            // paper_elevation8: '#FFFFFF' /* new */
            // paper_elevation12: '#FFFFFF' /* new */
            // paper_elevation16: '#FFFFFF' /* new */
            // paper_elevation24: '#E0E0E0' /* new */
        },
        button: {
            primary: "#1E5BCE",
            primary_text: "#FFFFFF",
            secondary: "#D2DEF5",
            secondary_text: "#133B86",
            tertiary: "#1E5BCE80", /// 50%,
            tertiary_text: "#1E5BCE",
        },
        divider: {
            divider: "#0000001f",
        },
        tag: {
            role: {
                admin: {
                    bg: "#B89BED",
                    text: "#000000",
                },
                operator: {
                    bg: "#5DC19F",
                    text: "#000000",
                },
                tech: {
                    bg: "#00000014", //8%
                    text: "#000000",
                },
                managed_else_where: {
                    bg: "#c74040",
                    text: "#FFFFFF",
                },
                custom: {
                    bg: "#EAA38A",
                    text: "#000000",
                },
            },
            area: {
                rg: {
                    bg: "#1D82B5",
                    text: "#ffffff",
                },
                aml: {
                    bg: "#DB8B0C",
                    text: "#ffffff",
                },
            },
        },
        link: {
            link: "#696969",
            colored: "#1E5BCE",
        },
        alerts: {
            success: {
                background: "#E6F8DD",
                color: "#2F461E",
            },
            error: {
                background: "#FDEFED",
                color: "#5F2720",
            },
            warning: {
                background: "#FFF5E5",
                color: "#663F00",
            },
            info: {
                background: "#E5F5FD",
                color: "#014161",
            },
        },
        status: {
            success: {
                lite: "#62AF27", /// Risk NO
                main: "#468515",
                deep: "#2B5908",
                contrast_text: "#FFFFFF",
                hover: "#4685150A", /// 4%
                selected: "#46851514", /// 8%
                focus: "#4685154D", /// 30%
                outline_border: "#46851580", /// 50%
            },
            error: {
                lite: "#E26555",
                main: "#DB3D28",
                deep: "#932011",
                contrast_text: "#FFFFFF",
                hover: "#DB3D280A", /// 4%
                selected: "#DB3D2814", /// 8%
                focus: "#DB3D284D", /// 30%
                outline_border: "#DB3D2880", /// 50%
            },
            warning: {
                lite: "#E49921",
                main: "#DB8B0C",
                deep: "#9D6306",
                contrast_text: "#FFFFFF",
                hover: "#DB8B0C0A", /// 4%
                selected: "#DB8B0C14", /// 8%
                focus: "#DB8B0C4D", /// 30%
                outline_border: "#DB8B0C80", /// 50%
            },
            info: {
                lite: "#3DB7F5",
                main: "#1D82B5",
                deep: "#0B5478",
                contrast_text: "#FFFFFF",
                hover: "#1D82B50A", /// 4%
                selected: "#1D82B514", /// 8%
                focus: "#1D82B54D", /// 30%
                outline_border: "#1D82B580", /// 50%
            },
            action: {
                active: "#0000008F", /// 56%,
                hover: "#0000000A", /// 4%,
                selected: "#00000014", /// 8%,
                focus: "#0000001F", /// 12%,
                disabled: "#00000061", /// 38%,
                disabled_background: "#0000001F", /// 12%,
            },
        },
        decoration: {
            decoration2: "#262673" /* dont think used */,
        },

        highlights: {
            lite: "#4DB6A1",
            main: "#009678",
            deep: "#0C6D5A",
            contrast_text: "#FFFFFF",
            hover: "#0096780A", // 4%
            selected: "#00967814", // 8%
            focus: "#0096784D", // 30%
            outline_border: "#00967880", // 50%
        },

        highlight: "#D83657" /* not used */,
        graphical: {
            1: "#EAA38A",
            2: "#CDB965",
            3: "#90C945",
            4: "#65CD6C",
            5: "#5DC19F",
            6: "#8BC1CC",
            7: "#99A6E6",
            8: "#B89BED",
            9: "#CC94D1" /* new */,
            // 10: '#D590A9' /* new */
        },
        priorities: {
            1: {
                background: "#FDEFED",
                text: "#5F2720",
            },
            2: {
                background: "#FDEFED",
                text: "#5F2720",
            },
            3: {
                background: "#FFF5E5",
                text: "#663F00",
            },
            4: {
                background: "#E5F5FD" /* new */,
                text: "#014161" /* new */,
            },
            5: {
                background: "#E5F5FD" /* new */,
                text: "#014161" /* new */,
            },
        },
        case_statuses: {
            open: {
                background: "#0000001F",
                surface1: "#000000",
            },
            in_progress: {
                background: "#E5F5FD",
                surface1: "#014161",
            },

            closed: {
                background: "#F1F7ED",
                surface1: "#2F461E",
            },
            error: {
                background: "#FBEAEA" /* not used */,
                surface1: "#D53E3D" /* not used */,
            },
        },
        risk_scores: {
            none: {
                background: "#0000001F", //12%
                color: "#0000001F",
                text: "#000000",
            },
            low: {
                background: "#0000001F", //12%
                color: "#468515",
                text: "#468515",
            },
            medium: {
                background: "#0000001F", //12%
                color: "#DB8B0C",
                text: "#DB8B0C",
            },
            high: {
                background: "#0000001F", //12%
                color: "#DB3D28",
                text: "#DB3D28",
            },
        },
        timelineKpis: {
            amountBet: { base: "#5C6BBD", gradient: "#5090EB" },
            amountLostWon: { base: "#D83657", gradient: "#E55B77" },
            amountDeposited: { base: "#226D47", gradient: "#92D3B2" },
            numberOfDeposits: { base: "#1D687C", gradient: "#97D4E8" },
            amountWithdrawn: { base: "#8D5221", gradient: "#F6C888" },
            playDuration: { base: "#AD4989", gradient: "#DF83D0" },
            rgRiskScore: { base: "black", gradient: "white" },
            amlRiskScore: { base: "grey", gradient: "#B0B0B0" },
        },
        timelineEvents: {
            interaction: { base: "#226D47", gradient: "#92D3B2" },
            playbreak: { base: "#D83657", gradient: "#E55B77" },
            limitChange: { base: "#262673", gradient: "#5090EB" },
            incident: { base: "#8D5221", gradient: "#F6C888" },
            message: { base: "#226D47", gradient: "#92D3B2" },
            timeLimit: { base: "#A39300", gradient: "#C9BA33" },
            moneyLimit: { base: "#A39300", gradient: "#C9BA33" },
            limitExceeded: { base: "#A39300", gradient: "#C9BA33" },
            login: { base: "#A39300", gradient: "#C9BA33" },
        },
        neccton: {
            loading_indicator: {
                color: "#767676",
            },
        },
    },
};
